module.exports = __webpack_public_path__ + "media/packs/images/partners/back_alive_logo-28acd7a1d5526ab12ea36c2023def44e.jpg";